import { AfterContentInit, Component, ElementRef, HostListener, Input, OnInit, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { SubNavItem } from './sub-nav-item.interface';
import { MediaService } from '../../../core/services';


/**
 * Component class for sticky sub nav
 */
@Component({
    selector: 'rms-sub-nav',
    styleUrls: ['./sub-nav.component.scss'],
    templateUrl: './sub-nav.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SubNavComponent implements OnInit, AfterContentInit {
  private stickyNav: any;
  public menuOpen = false;


  @Input() subMenuItems: Array<SubNavItem>;
  @ViewChild('navBar', { static: true }) navBar: ElementRef;
  @ViewChild('parentRef', { static: true }) parentRef: ElementRef;
  @HostListener('window:scroll', []) onScrollHandler() {
    this.handleScroll();
  }
  @HostListener('window:resize', []) onResizeHandler() {
    this.setStickyNav();
  }

  constructor(private renderer: Renderer2, private mediaService: MediaService) {}

  ngOnInit() {}

  ngAfterContentInit() {
    this.setStickyNav();
  }

  private setStickyNav() {
    this.stickyNav = this.navBar.nativeElement.offsetTop;
  }

  /**
   * Handles window scroll and sub nav position
   */
  private handleScroll() {
    const headerGap = this.mediaService.getMainHeaderHeight();
    const headerNav: any = document.getElementById('sub-nav');

    if (window.pageYOffset >= this.stickyNav - headerGap) {
      this.renderer.addClass(this.navBar.nativeElement, 'is-sticky');
      this.renderer.setStyle(
        this.parentRef.nativeElement,
        'margin-bottom',
        headerNav.offsetHeight + 'px'
      );
    } else {
      this.renderer.removeClass(this.navBar.nativeElement, 'is-sticky');
      this.renderer.setStyle(
        this.parentRef.nativeElement,
        'margin-bottom',
        '0'
      );
    }

    this.setActiveNavItem();
  }

  /**
   * Sets the active menu items based on the section id
   */
  private setActiveNavItem() {
    const headerGap = this.mediaService.getHeaderOffset();
    const gapExcessBefore = 20;

    for (let i = 0; i < this.subMenuItems.length; i++) {
      const el: HTMLElement = document.getElementById(
        this.subMenuItems[i].sectionId
      );
      const sectionRect: any = (el as HTMLElement).getBoundingClientRect();
      if (sectionRect.top <= headerGap + gapExcessBefore) {
        this.subMenuItems.forEach(item => {
          item.active = false;
        });
        this.subMenuItems[i].active = true;
      }
    }
  }

  /**
   * Handles sub nav click to scroll to section
   * @param {string} sectionId
   */
  public scrollToSection(sectionId: string) {
    const el: HTMLElement = document.getElementById(sectionId);

    this.subMenuItems.forEach(item => {
      item.active = false;
    });
    this.menuOpen = false;
    if (el) {
      setTimeout(() => {
        const headerOffset = this.mediaService.getHeaderOffset();
        const elementPosition = el.offsetTop;
        const offsetPosition = elementPosition - headerOffset;
        window.scrollTo({
          top: offsetPosition,
          // behavior: 'smooth'
        });
      }, 100);
    }
  }
}
